import { useMutation } from '@tanstack/react-query';
import APIClient from '@/services/APIClient';
import BaseServices from '@/services/BaseServices';
import SeatStatusPayload from '@/apiModels/SeatStatusPayload';

const useUpdateEventSeat = ({ cb, cbError, cbSuccess }: IMutationHookProps<SeatStatusPayload>) => {
  return useMutation<
    SeatStatusPayload,
    CustomError<RevelErrorResponse>,
    UpdateSeatReservationRequest<SeatStatusPayload>
  >({
    mutationFn: ({ payload, eventId, seatId }) => {
      const apiClient = new APIClient<SeatStatusPayload>(
        BaseServices.SEAT_RESERVATION_SERVICE,
        `/user-app/admin/event/${eventId}/seat/${seatId}/update-event-seat`,
      );
      return apiClient.update<SeatStatusPayload>(payload);
    },
    onSuccess: cbSuccess,
    onError: cbError,
    onMutate: cb,
  });
};

export default useUpdateEventSeat;
